// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  padding-bottom: 0rem;
  max-height: -moz-fit-content;
  max-height: fit-content;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 75%;
    margin: 1.75rem auto;
  }
}
::ng-deep .onboarding-personal-data-modal .title-modal, ::ng-deep .onboarding-cmr-data-modal .title-modal {
  font-size: 2rem;
  letter-spacing: -0.26px;
  font-weight: 200;
  color: #686868;
}
::ng-deep .onboarding-personal-data-modal .sub-title-modal, ::ng-deep .onboarding-cmr-data-modal .sub-title-modal {
  color: #686868;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
}

.row__footer-btn {
  margin-top: -80px;
  z-index: 100;
  position: relative;
}
.row__footer-btn > div {
  display: flex;
}
.row__footer-btn > div .container-form {
  margin: auto;
  flex: 1;
  text-align: center;
}
.row__footer-btn > div .btn {
  max-width: 465px;
  margin: auto;
}

.gray-container {
  background-color: #F4F7F8;
  padding: 1.2em 1.5em 0.5em 1.5em;
  margin: 1em 0 1em 0;
}

.center-item {
  text-align: center;
}

.font14 {
  font-size: 14px;
}

.initial-line {
  background-color: #F4F7F8;
  height: 40px;
  border-radius: 6px;
  font-size: 15px;
  margin-bottom: 1.5em;
  width: 100%;
}
@media (min-width: 768px) and (max-width: 991px) {
  .initial-line {
    height: 50px;
  }
}

.tcea-container {
  margin-top: 20px;
}
.tcea-container .tcea-img-container {
  margin-bottom: 15px;
}
.tcea-container .tcea-img-container img {
  margin-right: 15px;
}
.tcea-container .tcea-text-container {
  text-align: justify;
}

.custom-checkbox label {
  font-size: 1rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
